import { Link } from "react-router-dom";
import { Instagram, ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocale } from "@/hooks/use-locale";
import { trackNavClick, trackCTAClick } from "@/lib/analytics";

const AMAZON_STORE = "https://www.amazon.com/stores/Kalianii-MotherlyLoveandLight/page/2E97BFF2-3CBA-47CB-8B3D-3D77AF27DFD0";

const Footer = () => {
  const { t } = useTranslation();
  const { prefix } = useLocale();

  return (
    <footer className="bg-[#2A2A2A] text-gray-300">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-bold text-white text-lg mb-1">Queebi</h4>
            <p className="text-xs uppercase tracking-wide text-gray-400 mb-1 font-semibold">{t("footer.brandLine1")}</p>
            <p className="text-xs text-gray-500 mb-3">{t("footer.brandLine2")}</p>
            <p className="text-sm leading-relaxed text-gray-400">
              {t("footer.tagline")}
            </p>
            <a
              href="https://www.instagram.com/queebi.land/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackCTAClick('instagram_footer')}
              className="inline-flex items-center gap-2 mt-4 text-sm hover:text-queebi-teal transition-colors font-medium"
            >
              <Instagram className="h-4 w-4" /> @queebi.land
            </a>
          </div>

          <div>
            <h4 className="font-bold mb-3 text-white">{t("footer.explore")}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to={`${prefix}/queebi-products`} onClick={() => trackNavClick('footer_products')} className="hover:text-queebi-teal transition-colors font-semibold">{t("footer.shop")}</Link></li>
              <li className="pt-1 text-xs uppercase tracking-wide text-gray-500">{t("footer.queebiLand")}</li>
              <li><Link to={`${prefix}/queebi-land-characters`} onClick={() => trackNavClick('footer_characters')} className="hover:text-queebi-teal transition-colors pl-2 block">{t("footer.characters")}</Link></li>
              <li><Link to={`${prefix}/story-of-queebi-land`} onClick={() => trackNavClick('footer_story')} className="hover:text-queebi-teal transition-colors pl-2 block">{t("footer.story")}</Link></li>
              <li><Link to={`${prefix}/activities`} onClick={() => trackNavClick('footer_activities')} className="hover:text-queebi-teal transition-colors pl-2 block">{t("footer.activities")}</Link></li>
              <li><Link to={`${prefix}/audiobook`} onClick={() => trackNavClick('footer_audiobook')} className="hover:text-queebi-teal transition-colors pl-2 block">{t("footer.audiobook")}</Link></li>
              <li className="pt-1"><Link to={`${prefix}/blog`} onClick={() => trackNavClick('footer_blog')} className="hover:text-queebi-teal transition-colors">{t("footer.blog")}</Link></li>
              <li><Link to={`${prefix}/about-us`} onClick={() => trackNavClick('footer_about')} className="hover:text-queebi-teal transition-colors">{t("footer.aboutUs")}</Link></li>
              <li><Link to={`${prefix}/collaborate`} onClick={() => trackNavClick('footer_collaborate')} className="hover:text-queebi-teal transition-colors">{t("footer.collaborate")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-3 text-white">{t("footer.contact")}</h4>
            <p className="text-sm leading-relaxed mb-3 text-gray-400">
              {t("footer.contactDesc")}
            </p>
            <a href="mailto:hello@queebi.com.tw" className="text-sm hover:text-queebi-teal transition-colors">
              hello@queebi.com.tw
            </a>
            <div className="mt-4">
              <a
                href={AMAZON_STORE}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackCTAClick('shop_amazon_footer')}
                className="inline-flex items-center gap-2 text-sm hover:text-queebi-teal transition-colors font-medium"
              >
                <ShoppingCart className="h-4 w-4" /> {t("footer.shopOnAmazon")}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-700 text-center text-xs text-gray-300">
          <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
